export enum FileStatus {
  LOADING = 'loading',
  PREPARE = 'prepare',
  ERROR = 'Error',
  LOADED = 'Loaded'
}

export interface FileInfo {
  name: string
  status: FileStatus
  type: string
  path: string
  basePath?: string
  isDirectory: boolean
  isFile?: boolean
  file?: File
  error?: string
  message?: string
  parent?: string
  folderId?: string
}

export enum ActionDuplicateFile {
  SAVE = 'save',
  SAVE_BOTH = 'saveBoth',
  REPLACE = 'replace'
}
